import { useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/ConfigurationExplorer.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { LoadShortDate } from "../../../../functions/LoadShortDate";
import { LoadShortTime } from "../../../../functions/LoadShortTime";
const ConfigurationExplorer = ({accessToken,showConfigurationExplorer,setShowConfigurationExplorer,showNewConfiguration,setShowNewConfiguration}) =>{
    const [configurationTemplates,setConfigurationTemplates] = useState(null);
    const fetchConfigurationTemplates = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/devices/configurations/templates/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setConfigurationTemplates(responseData);
            }
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        const fetchTemplates = async() =>{
            if(showConfigurationExplorer && !showNewConfiguration) await fetchConfigurationTemplates();
        };
        fetchTemplates();
    },[showConfigurationExplorer,showNewConfiguration]);
    if(!showConfigurationExplorer || showNewConfiguration) return null;
    return(
        <div className="device-configuration-explorer">
            <div className="device-configuration-explorer-header">
                <h3>Configuration explorer</h3>
                <p onClick={() => setShowConfigurationExplorer(false)}>&#10006;</p>
            </div>
            <div className="device-configuration-explorer-body">
                <table className="device-configuration-explorer-summary-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Date created</th>
                            <th>Time created</th>
                            <th style={{paddingLeft:'25px'}}>
                                <button className="add-new-configuration-button" onClick={() => {setShowNewConfiguration(true)}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add configuration" title="Add configuration" />
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {configurationTemplates && configurationTemplates.map(configurationTemplate => (
                            <tr key={configurationTemplate.id}>
                                <td>{configurationTemplate.name}</td>
                                <td>{LoadShortDate(configurationTemplate.createDate)}</td>
                                <td>{LoadShortTime(configurationTemplate.createDate)}</td>
                                <td>
                                    <div className="device-configuration-explorer-summary-table-control-buttons-container">
                                        <button>
                                            <img src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} alt="Edit configuration" title="Edit configuration" />
                                        </button>
                                        <button>
                                            <img src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} alt="Delete configuration" title="Delete configuration" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default ConfigurationExplorer;